module.exports = __webpack_public_path__ + "img/faild.55b3e0cf.png";